import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { ListItem } from 'Lib/List'
import { Truncate } from 'Lib/Text'
import { CLEVERTAP_EVENT_NAME, CLEVERTAP_PLATFORM } from 'AccountsConstants/clevertap'
import { AccountsContext } from 'AccountsContext'
import { isRouteLinkAvailable, navigateToExternalLink, triggerClevertap } from 'AccountsUtils'
import { ROUTER_BASE_PATH, LOAD_HOME, SETTINGS_LINK } from 'AccountsConstants/routes'
import { SUPPORT_HEADER, SETTINGS_HEADER } from 'AccountsConstants/language/account'
import AccountIcon from './AccountIcon'

const AccountListItem = ({ accountListInfo, loggedIn }) => {
  const { openModal } = useContext(AccountsContext)
  const { icon, link, label, description } = accountListInfo
  const routePage = (itemLink, itemLabel) => () => {
    if (!loggedIn) {
      return
    }
    if (!isRouteLinkAvailable(itemLink) && itemLabel === SUPPORT_HEADER) {
      const clevertapData = {
        'event type': 'support_button_clicked',
        platform: CLEVERTAP_PLATFORM,
        current_page_name: 'account',
        last_page_name: 'NA'
      }
      triggerClevertap(CLEVERTAP_EVENT_NAME, clevertapData)
      // navigateToExternalLink(SUPPORT_LINK)
      openModal()
    } else if (!isRouteLinkAvailable(itemLink) && itemLabel === SETTINGS_HEADER) {
      navigateToExternalLink(SETTINGS_LINK)
    }
  }
  return (
    <React.Fragment>
      <ListItem arrow={true} enableRipple={true}>
        <Link to={`${link || `${ROUTER_BASE_PATH}${LOAD_HOME}`}`} className="flag h-15" onClick={routePage(link, label)}>
          <div className="flag__fix amr-10">
            <AccountIcon icon={icon} />
          </div>
          <div className="flag__flex">
            <h5 className="fs-17 lh-solid apr-10 t-truncate">
              {label}
            </h5>
            <Truncate className="fs-14 lh-copy c-black-50" width="98%">
              {description}
            </Truncate>
          </div>
        </Link>
      </ListItem>
    </React.Fragment>
  )
}

export default AccountListItem
